import styled from "styled-components";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { defaultCompare } from "logic/DefaultCompare";
import { Checkbox, DropdownButton, MenuItem, DeleteMenuItem } from "components/bootstrap";
import TextOverflowEllipsis from "components/common/TextOverflowEllipsis";
import { Icon } from "components/common";
const StyledDropdownButton = styled(DropdownButton)`
  ~ .dropdown-menu {
    min-width: auto;
    max-width: 180px;
  }
`;
const ColumnCheckbox = styled(Checkbox)`
  &.checkbox {
    margin: 0 5px 0 0;

    label {
      display: flex;
      align-items: center;
      padding: 0;

      input {
        margin: 0;
        position: relative;
      }
    }
  }
`;
const ListItemInner = styled.div`
  display: flex;
`;
const ColumnTitle = styled(TextOverflowEllipsis)`
  display: inline;
`;
const colLabel = (column) => {
  var _a, _b;
  return (_b = (_a = column.columnDef.meta) == null ? void 0 : _a.label) != null ? _b : column.id;
};
const ColumnListItem = ({ column }) => {
  const isSelected = column.getIsVisible();
  const toggleVisibility = () => column.toggleVisibility();
  const label = colLabel(column);
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(
    MenuItem,
    {
      onSelect: toggleVisibility,
      title: isSelected ? t("entity_table.hide_column_named", { column: label }) : t("entity_table.show_column", { column: label })
    },
    /* @__PURE__ */ React.createElement(ListItemInner, null, /* @__PURE__ */ React.createElement(ColumnCheckbox, { checked: isSelected, onChange: toggleVisibility }), /* @__PURE__ */ React.createElement(ColumnTitle, null, label))
  );
};
const ColumnsVisibilitySelect = ({
  table,
  onResetLayoutPreferences,
  hasColumnLayoutPreferences
}) => {
  const { t } = useTranslation("common");
  return /* @__PURE__ */ React.createElement(
    StyledDropdownButton,
    {
      title: t("entity_table.columns"),
      withinPortal: true,
      bsSize: "small",
      pullRight: true,
      "aria-label": t("entity_table.configure_columns"),
      id: "columns-visibility-select",
      bsStyle: "default",
      closeOnItemClick: false
    },
    table.getAllLeafColumns().filter((column) => column.getCanHide()).sort((col1, col2) => defaultCompare(colLabel(col1), colLabel(col2))).map((column) => /* @__PURE__ */ React.createElement(ColumnListItem, { column, key: column.id })),
    /* @__PURE__ */ React.createElement(MenuItem, { divider: true }),
    /* @__PURE__ */ React.createElement(DeleteMenuItem, { disabled: !hasColumnLayoutPreferences, onSelect: onResetLayoutPreferences, closeMenuOnClick: true }, /* @__PURE__ */ React.createElement(Icon, { name: "reopen_window" }), " ", t("entity_table.reset_columns"))
  );
};
export default ColumnsVisibilitySelect;
